import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { getSeasonsSingle, updateSeason } from "../../../../services/season";
import { useEffect, useState } from "react";
import { emptySeason, Season } from "../../../../interfaces/season";
import { Media } from "../../../../interfaces/media";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminSeasonEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminSeasonEdit(props: AdminSeasonEditProps) {
    const [season, setSeason] = useState<Season>(emptySeason);

    useEffect(() => {
        getSeasonsSingle(props.id)
            .then(response => {
                setSeason(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            name: event.target.name.value,
            date_start: event.target.date_start.value,
            date_end: event.target.date_end.value
        }
        updateSeason(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    return (
        <Modal className="admin-season-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_season") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { season.id == 0 && 
                    <LoadingSpinner />
                }
                { season.id != 0 && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Group className="mb-3" controlId="id">
                                <Form.Control type="hidden" name="id" required 
                                    defaultValue={ season.id } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required
                                    defaultValue={ season.name } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="date_start">
                                <Form.Label aria-required="true">{ t("Start date") }</Form.Label>
                                <Form.Control type="date" name="date_start" required
                                    defaultValue={ season.date_start } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="date_end">
                                <Form.Label aria-required="true">{ t("End date") }</Form.Label>
                                <Form.Control type="date" name="date_end" required
                                    defaultValue={ season.date_end } />
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}